import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { DEFAULT_LOCALE } from '@/locales/default-locale'

const COURSE_SIDEBAR_KEY: string = 'courseSidebarOpen';

@Module({
    namespaced: true,
    name: 'root',
    store,
    dynamic: true
})
class RootModule extends VuexModule {
    public selectedLocale: string = DEFAULT_LOCALE;
    public sidebarIsOpen: boolean = localStorage.getItem(COURSE_SIDEBAR_KEY) === '1' || localStorage.getItem(COURSE_SIDEBAR_KEY) === null;
    public isFirstLoad: boolean = true;

    @Mutation
    public setSelectedLocale(selectedLocale: string): void {
        this.selectedLocale = selectedLocale;
    }

    @Mutation
    public setSidebarIsOpen(value: boolean): void {
        localStorage.setItem(COURSE_SIDEBAR_KEY, value ? '1' : '0');
        this.sidebarIsOpen = value;
    }

  @Mutation
  public setIsFirstLoad(value: boolean): void {
    this.isFirstLoad = value;
  }
}

export default getModule(RootModule);
